import { render, staticRenderFns } from "./CurrentWord.vue?vue&type=template&id=8e4c6f4c&scoped=true&"
import script from "./CurrentWord.vue?vue&type=script&lang=js&"
export * from "./CurrentWord.vue?vue&type=script&lang=js&"
import style0 from "./CurrentWord.vue?vue&type=style&index=0&id=8e4c6f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4c6f4c",
  null
  
)

export default component.exports